import { Link, NavLink } from "react-router-dom";
import { Store as StoreIcon } from "lucide-react";
import StoreCartIcon from "./StoreCartIcon";

const links = [
  { to: "/store", label: "Browse" },
  { to: "/store/orders", label: "Orders" },
  { to: "/store/vendor", label: "Vendor portal" },
];

const StoreSubnav = () => (
  <div className="border-b border-border/60 bg-background/95 backdrop-blur sticky top-0 z-30">
    <div className="mx-auto w-full max-w-7xl px-6 h-14 flex items-center justify-between">
      <Link to="/store" className="flex items-center gap-2 font-semibold">
        <StoreIcon className="h-5 w-5 text-primary" />
        <span>Wavlynq Store</span>
      </Link>
      <nav className="flex items-center gap-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/store"}
            className={({ isActive }) =>
              `px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive ? "bg-muted text-foreground" : "text-muted-foreground hover:text-foreground"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
        <StoreCartIcon />
      </nav>
    </div>
  </div>
);

export default StoreSubnav;
